export default __webpack_public_path__ + "static/media/6.28fb9285.jpg";